import React, { useState, useEffect, useCallback } from "react";
import { Card } from "react-bootstrap";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  initialEmployeeForm,
  employeeValidation,
  employeeExtraToChange,
  employeeFieldRules,
  WidgetBox,
  preTrainingValidation,
} from "./Constant";

import { useHistory, useParams } from "react-router-dom";
import {
  createEmployee,
  getEmployeeByID,
  updateBasicDetailsOfEmployee,
  updateEmployee,
} from "app/_services/UserManagement/EmployeeService";
import toastr from "toastr";
import EmployeeForm from "./Component/EmployeeForm";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { confirmAlert } from "react-confirm-alert";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import { Validation } from "app/_helpers/validation/Validation";
import EmployeeId from "./Component/EmployeeId";
import { CommmonService } from "app/_services/CommonService/CommonService";

function EditEmployee() {
  const [form, setForm] = useState({ ...initialEmployeeForm });
  const [previousTraining, setPreviousTraining] = useState([]);
  const [preTrainingErr, setPreTrainingErr] = useState([]);
  const [error, setError] = useState({});
  const { push } = useHistory();
  const { id } = useParams();
  const [siteList, setSiteList] = useState([]);
  const [submitFlag, setSubmitFlag] = useState(false);

  const onChange = async ({ target: { name, value, type, checked } }) => {
    if (name === "aadharNumber") {
      if (value.length === 12) {
        let response = await CommmonService.aadharCheck({
          id,
          aadharNumber: value,
          moduleName: "Employee",
        });
        if (!response?.status) {
          setError((prev) => ({
            ...prev,
            aadharNumber:
              "This AAdhar Number is already used by " +
              response.data?.firstName +
              " " +
              response.data?.middleName +
              " " +
              response.data?.lastName,
          }));
        } else {
          setError((prev) => ({
            ...prev,
            aadharNumber: "",
          }));
        }
      } else {
        setError((prev) => ({
          ...prev,
          aadharNumber: "Aadhar Number should be of 12 digit",
        }));
      }
    }

    if (name === "employeeId") {
      // if (value.length === 12) {
      let response = await CommmonService.eployeeIdCheck({
        id,
        employeeId: value,
        moduleName: "Employee",
      });
      if (!response?.status) {
        setError((prev) => ({
          ...prev,
          employeeId:
            "This Employee Id is already used by " +
            response.data?.firstName +
            " " +
            response.data?.middleName +
            " " +
            response.data?.lastName,
        }));
      } else {
        setError((prev) => ({
          ...prev,
          employeeId: "",
        }));
      }
    }

    let extraToChange = {};
    if (name === "isPmeDate" && value !== form?.isPmeDate) {
      extraToChange.pmeDate = "";
      extraToChange.pmeCertificateNo = "";
      extraToChange.pmeCertificateId = null;
    }

    if (name === "isIMEDate" && value !== form?.isIMEDate) {
      extraToChange.imeDate = "";
      extraToChange.imeCertificateNo = "";
      extraToChange.imeCertificateId = null;
    }

    // if (name === "designation" && id) {
    //   confirmAlert({
    //     title: "Please update Training designation",
    //     message: "Do you want to proceed?",
    //     buttons: [
    //       {
    //         label: "Yes",
    //         onClick: async () => {
    //           let extraToChange = employeeExtraToChange(name, value, siteList);

    //           setForm((prev) => ({
    //             ...prev,
    //             ...extraToChange,
    //             [name]: type === "checkbox" ? checked : value,
    //           }));
    //         },
    //       },
    //       {
    //         label: "No",
    //         onClick: () => {},
    //       },
    //     ],
    //   });

    //   return false;
    // }
    // let extraToChange = employeeExtraToChange(name, value, siteList, form);

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      let errorObj = employeeValidation(form);
      let isPreTraErr =
        previousTraining?.length && form.siteType === 3
          ? preTrainingValidation(previousTraining, setPreTrainingErr)
          : "";
      // console.log("/*/*/*/employeeValidation", errorObj);
      // errorObj.pmeDate = "";
      errorObj.specialMedicalExamCategory = "";
      errorObj.specialMedicalExamEligibility = "";
      errorObj.startDateAtMines = "";
      errorObj.trainingDesignation = "";
      errorObj.trainingEligibility = "";
      errorObj.designationChangeTrainingDate = "";
      errorObj.designationChangeTrainingStatus = "";
      errorObj.currentWorkLocation = "";
      errorObj.mineTag = "";
      errorObj.siteType = "";

      setSubmitFlag(true);
      // return;
      setError((prev) => ({ ...errorObj }));

      // if (form.aadharNumber.length === 12) {
      //   let response = await CommmonService.aadharCheck({
      //     id,
      //     aadharNumber: form.aadharNumber,
      //     moduleName: "Employee",
      //   });
      //   if (!response?.status) {
      //     setError((prev) => ({
      //       ...prev,
      //       ...errorObj,
      //       aadharNumber:
      //         "This AAdhar Number is already used by " +
      //         response.data?.firstName +
      //         " " +
      //         response.data?.middleName +
      //         " " +
      //         response.data?.lastName,
      //     }));
      //   } else {
      //     setError((prev) => ({ ...prev, ...errorObj }));
      //   }
      // } else {
      //   setError((prev) => ({
      //     ...prev,
      //     ...errorObj,
      //     aadharNumber: "Aadhar Number should be of 12 digit",
      //   }));
      // }

      // let res = await CommmonService.eployeeIdCheck({
      //   id,
      //   employeeId: form.employeeId,
      //   moduleName: "Employee",
      // });
      // if (!res?.status) {
      //   setError((prev) => ({
      //     ...prev,
      //     ...errorObj,
      //     employeeId:
      //       "This Employee ID is already used by " +
      //       res.data?.firstName +
      //       " " +
      //       res.data?.middleName +
      //       " " +
      //       res.data?.lastName,
      //   }));
      // } else {
      //   setError((prev) => ({
      //     ...prev,
      //     ...errorObj,
      //   }));
      // }

      if (isPreTraErr || Object.values(errorObj).filter((d) => d !== "").length) return;

      let duplicateFlag = 0;
      let duplicateData = [];
      if (previousTraining?.length && form.siteType === 3) {
        previousTraining.forEach((d) => {
          if (duplicateData.includes(+d.trainingDesignation)) duplicateFlag++;
          else !d.deleted && duplicateData.push(+d.trainingDesignation);
        });
      }
      if (duplicateFlag) {
        toastr.error(
          "Training Designation should not duplicate in Previous Training Record."
        );
        return;
      }

      let formObj = JSON.parse(JSON.stringify(form));

      formObj.previousTrainingData = form.siteType === 3 ? previousTraining : [];
      let response = await updateBasicDetailsOfEmployee(id, {
        employee: formObj,
      });
      if (!response?.status) {
        // if (response?.message === "This AAdhar Already Exist") {
        //   setError((prev) => ({
        //     ...prev,
        //     ...errorObj,
        //     aadharNumber:
        //       "This AAdhar Number is already used by " +
        //       response.data?.firstName +
        //       " " +
        //       response.data?.middleName +
        //       " " +
        //       response.data?.lastName,
        //   }));
        // }
        return toastr.error(response?.message);
      }

      toastr.success(response.message || "Success.");
      push(`/user-management/employee`);
    },
    [form, id, previousTraining, push]
  );
  const history = useHistory();

  useEffect(() => {
    if (!id) return;

    getEmployeeByID(id).then((response) => {
      // console.log("response/**/**", response);
      if (!response?.status) {
        history.push("/user-management/employee");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const employeeData = response.data.employees || {};

      setForm({
        ...response.data.employees,
        siteType: employeeData?.ehsSite?.siteType || "",
        designationChangeTrainingDate: employeeData?.designationChangeTrainingDate || "",
        designationChangeTrainingStatus:
          employeeData?.designationChangeTrainingStatus || "",
        dateOfJoining: employeeData?.dateOfJoining || "",
        dateOfSeparation: employeeData?.dateOfSeparation || "",
        isPmeDate: employeeData?.isPmeDate ? true : false,
        isIMEDate: employeeData?.isIMEDate ? true : false,
        pmeDate: employeeData?.lastPMEDate,
        imeDate: employeeData?.lastIMEDate,
        certificateFile: {
          imeCertificateId: employeeData?.imefile || null,
          pmeCertificateId: employeeData?.pmefile || null,
        },
      });
      setPreviousTraining(employeeData?.previousTrainingData || []);
    });
  }, [id]);

  useEffect(() => {
    getAllSiteList();
  }, []);

  const getAllSiteList = async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  };

  // useEffect(() => {
  //   if (!submitFlag) return;
  //   let errorObj = employeeValidation(form, siteList);

  //   setError((prev) => ({
  //     ...errorObj,
  //   }));
  // }, [form, siteList, submitFlag]);

  console.log("previousTraining++++", previousTraining);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          { name: "Employee", path: "/user-management/employee" },
          { name: `${id ? "Edit" : "Add"} Employee`, path: "#" },
        ]}
      />

      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">{id ? "Edit" : "Add"} Employee</h3>

            <EmployeeId id={id} form={form} employeeId={form.employeeId} />
          </Card.Title>

          <WidgetBox form={form} />
          <EmployeeForm
            siteList={siteList}
            form={form}
            onChange={onChange}
            error={error}
            id={id}
            previousTraining={previousTraining}
            setPreviousTraining={setPreviousTraining}
            preTrainingErr={preTrainingErr}
          />

          <FormBtn id={id} onSubmit={onSubmit} backUrl={"/user-management/employee"} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default EditEmployee;
